module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am638-4f8261fc82263807543316fb1409e897.jpg";